import { render, staticRenderFns } from "./GroupTypeTable.vue?vue&type=template&id=5326fed4&"
import script from "./GroupTypeTable.vue?vue&type=script&lang=js&"
export * from "./GroupTypeTable.vue?vue&type=script&lang=js&"
import style0 from "./GroupTypeTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports